import * as React from 'react';
import {useLocation} from 'src/rerouter/index';

import ErrorBoundary from 'src/components/lib/error-boundary';

import RuntimeError from './runtime-error';


type Props = {
  children: React.ReactNode;
  onError?: (arg1: Error) => unknown;
  id?: unknown;
};

export default function RuntimeErrorBoundary(props: Props) {
  return <ErrorBoundary {...props} fallback={() => <RuntimeError />} />;
}

export function RouterErrorBoundary(props: Props) {
  const location = useLocation();

  return <RuntimeErrorBoundary {...props} id={location.pathname} />;
}
